import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingOverlay = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // semi-transparent black overlay
        zIndex: 9999, // ensure it's above other content
      }}
    >
      <CircularProgress color="secondary" />
    </div>
  );
};

export default LoadingOverlay;
